import * as React from 'react';
import cx from 'classnames';
import AccountSection from './AccountSection';
import ValueSection from './ValueSection';
import EngageList from './EngageList';
import { Image } from 'src/widgets/Image';
import { useState, useEffect } from 'react';
import styles from './PostCard.scss';

export interface ISocialPost {
  post_id: string;
  post_type: string;
  network: string;
  mention_id: number;
  reach: string;
  datetime_posted?: string;
  profile_image_url?: string;
  social_account_name?: string;
  social_account_link?: string;
  image_url?: string;
  link?: string;
  creator: string;
  post_text?: string;
  post_image_tags?: string[];
  clicks?: string;
  closeups?: string;
  comments?: string;
  dislikes?: string;
  exits?: string;
  favorites?: string;
  impressions?: string;
  likes?: string;
  shares?: string;
  taps?: string;
  unique_impressions?: string;
  views?: string;
  tmv?: string;
  roi_pct?: string;
  cost?: string;
  product_cost?: string;
}

interface IProps {
  post: ISocialPost;
  isQa: boolean;
  hideValueSection?: boolean;
}

/**
 * @type {React.FunctionComponent}
 */
export const PostCard: React.FunctionComponent<IProps> = React.memo((props) => {
  const { post, hideValueSection, isQa } = props;
  const [imageUrl, setImageUrl] = useState<string>(post.image_url);

  const getFreshThumbnailUrl = async (postLink: string) => {
    try {
      const resp = await fetch(
        `https://graph.facebook.com/v10.0/instagram_oembed?url=${postLink}&media_url&access_token=491285117675871|b23dbfa4e920b87abd9f925864958104`
      );

      if (!resp.ok) {
        throw new Error(`Instagram oembed failed with status: ${resp.status || 0}`);
      }

      const json = await resp.json();

      if (json.thumbnail_url) {
        return json.thumbnail_url;
      }
    }
    catch (e) {
      throw new Error(e);
    }
  };

  const getImageUrl = async () => {
    if (post.post_type !== 'instagram') {
      return;
    }

    if (post.post_type === 'instagram') {
      try {
        const resp = await fetch(post.image_url);
        if (resp.ok === true) {
          setImageUrl(post.image_url);
        }
        else {
          const image_url = await getFreshThumbnailUrl(post.link);
          setImageUrl(image_url);
        }
      }
      catch (e) {
        const image_url = await getFreshThumbnailUrl(post.link);
        setImageUrl(image_url);
        throw new Error(e);
      }
    }
  };

  useEffect(() => {
    setImageUrl(post.image_url);
    getImageUrl();
  }, [post.image_url]);

  return (
    <a
      className={styles.ClearLink}
      href={post.link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className={styles.PostCard}>
        <section className={styles.contentImageContainer}>
          <div className={styles.contentContainer}>
            <div className={styles.TopShadow} />
            <Image src={imageUrl} className={styles.imgContent}></Image>
            <div className={styles.captionContainer}>
              <span className={cx(styles.captionTxt, styles.truncate)}>
                {post.post_text}
              </span>
            </div>
          </div>
        </section>
        <section className={styles.InfoContainer}>
          <EngageList post={post} />
          {!hideValueSection && <ValueSection post={post} />}
          <AccountSection isQa={isQa} post={post} />
        </section>
      </div>
    </a>
  );
});
